import { IReportTuyenSinhRequest } from "../../../model/request/report/IReportTuyenSinhRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IReportTuyenSinhRespone } from "../../../model/respone/report/IReportTuyenSinhRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eReportTuyenSinhActionsObj = {
  LOAD_START: {} as IReportTuyenSinhRequest,
  LOAD_SUCCESS: {} as IPagingResult<IReportTuyenSinhRespone[]>,
  LOAD_ERROR: {} as string,
  CHANGE_REPORT_FILTER: "",
  CHANGE_REQUEST: {} as any,
  SHOW_MODAL_LIST_BIEN_LAI: 0 as number,
  CLOSE_MODAL_LIST_BIEN_LAI: undefined,
  SHOW_HIDE_FILTER: {} as boolean,
};
export const eReportTuyenSinhActionIds = generateActionTypeIds(
  eReportTuyenSinhActionsObj,
  "REPORT_TUYEN_SINH"
);
export type IReportTuyenSinhActionTypes = IGenericActionType<
  typeof eReportTuyenSinhActionsObj,
  "REPORT_TUYEN_SINH"
>;
